import React from 'react';
import Footer from './Footer';
import './Menu.css';

const Menu=() =>
{
    return(
        <div className="body-menu">
            This is Menu page
            <br/>
            {/* <marquee>You can send your complaints or suggestions on our official email id: <NavLink to="/Contact.js" className="help">pankaj.phour70@gmail.com</NavLink>. Or you can call us at :- <NavLink to="/Contact.js" className="help"><strong>9518455298</strong></NavLink></marquee> */}
< Footer/>
        </div>
    )
};
export default Menu;
